import React from "react";
import CharacterAttacksTable from "./../components/CharacterAttacksTable.js";

const styledInfo = {
  paddingLeft: "20%",
  paddingRight: "20%",
};

const Attacks = () => {
  return (
    <>
      <div id="top" style={styledInfo} className="my-5">
        <center>
          <p className="lead">
            Below is a table of all attacks. You can filter and sort by columns.
          </p>
        </center>
      </div>
      <div id="AttacksTable" className="table-responsive">
        <CharacterAttacksTable />
      </div>
    </>
  );
};

export default Attacks;
